import {
  AUTH_STORAGE_KEYS,
  SUPER_ADMIN_ROLE,
  type IUser,
  type TAuthHeaders,
} from '@/types/auth';

export function readStoredUser(): IUser | null {
  const raw = localStorage.getItem(AUTH_STORAGE_KEYS.userData);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as IUser;
  } catch {
    return null;
  }
}

export function readEffectiveTenantId(): string | null {
  return localStorage.getItem(AUTH_STORAGE_KEYS.effectiveTenantId);
}

export function writeEffectiveTenantId(tenantId: string | null): void {
  if (tenantId) {
    localStorage.setItem(AUTH_STORAGE_KEYS.effectiveTenantId, tenantId);
  } else {
    localStorage.removeItem(AUTH_STORAGE_KEYS.effectiveTenantId);
  }
}

export function isSuperAdmin(user: Pick<IUser, 'role'> | null | undefined): boolean {
  return user?.role === SUPER_ADMIN_ROLE;
}

/** Resolve X-Tenant-Id só para super_admin com tenant escolhido. */
export function resolveXTenantIdHeader(user?: IUser | null): string | null {
  const current = user ?? readStoredUser();
  if (!isSuperAdmin(current)) return null;
  return readEffectiveTenantId();
}

export function withTenantHeader(headers: TAuthHeaders, user?: IUser | null): TAuthHeaders {
  const tenantId = resolveXTenantIdHeader(user);
  if (!tenantId) return headers;
  return { ...headers, 'X-Tenant-Id': tenantId };
}
